import axios from "axios";
import SettingEdit from "@/controllers/setting/setting-edit.js";
import CONFIG from "@/assets/js/config.js";

export default {
	...SettingEdit,
	name: "CustomSettingEdit",

	data() {
		return {
			...SettingEdit.data(),
			settings: {
				teacher_chat_approval: false,
				signature: null,
				send_notice_notifications: false,
				allow_referral_discount: false,
				facebook_integration: false,
				use_facebook_page: false,
				currency: '',
				report_card_grading: null,
				client_type: null,
				payment_slip_size: 0,
				school_start_time: null,
				school_end_time: null,
				employee_attendance_qr: null,
				tax_rate: null,
				discount_limit: 0,
        section_hourly_setting: CONFIG.SECTION_HOURLY_SETTING.SECTION,
				access_late_minute: null,
			},
      sectionHourlySetting: [],
      CONFIG,
		};
	},

	methods: {
		...SettingEdit.methods,

		/**
		 * get setting
		 */
		getSetting() {
			this.isLoading = true;
			axios
				.get("/setting/" + this.$store.state.user.campus_id)
				.then((response) => {
					this.settings.teacher_chat_approval = response.data.teacher_chat_approval == 1 ? true : false;
					this.settings.signature = this.signImage = response.data.signature;
					this.settings.send_notice_notifications = response.data.send_notice_notifications == 1 ? true : false;
					this.settings.allow_referral_discount = response.data.allow_referral_discount == 1 ? true : false;
					this.settings.use_facebook_page = response.data.use_facebook_page == 1 ? true : false;
					this.settings.currency = response.data.currency || 'MMK';
					this.settings.report_card_grading = response.data.report_card_grading || null;
					this.settings.school_start_time = response.data.school_start_time || null;
					this.settings.school_end_time = response.data.school_end_time || null;
					this.settings.employee_attendance_qr = response.data.employee_attendance_qr ?? null;
					this.settings.client_type = response.data.client_type || 'school';
          this.settings.payment_slip_size = response.data.payment_slip_size ?? 0;
          this.settings.tax_rate = response.data.tax_rate ? response.data.tax_rate * 100 : 0;
					this.settings.discount_limit = response.data.discount_limit || 0;
					this.settings.section_hourly_setting = this.normalizeSectionHourlySetting(response.data.section_hourly_setting);
					this.settings.access_late_minute = response.data.access_late_minute ?? null;
					if (this.isFbEnable) {
						this.settings.facebook_integration = true;
					} else {
						this.settings.facebook_integration = response.data.facebook_integration == 1 ? true : false;
					}
					this.isLoading = false;
				})
				.catch((error) => {
					if (error.response && error.response.status == 401) {
						this.$store.commit('logout');
						window.location.replace('login');
					}
				});
		},

		/**
		 * save setting
		 */	
		saveSetting() {
			this.isLoading = true;
			this.disabled = true;
			this.settings.teacher_chat_approval = this.settings.teacher_chat_approval ? 1 : 0;
			this.settings.facebook_integration = this.settings.facebook_integration ? 1 : 0;
			this.settings.send_notice_notifications = this.settings.send_notice_notifications ? 1 : 0;
			this.settings.allow_referral_discount = this.settings.allow_referral_discount ? 1 : 0;
			this.settings.use_facebook_page = this.settings.use_facebook_page ? 1 : 0;
			this.settings.signature = this.signImage == null ? '' : this.signImage;
			this.settings.currency = this.settings.currency ?? null;
			this.settings.school_start_time = this.settings.school_start_time ?? null;
			this.settings.school_end_time = this.settings.school_end_time ?? null;
			this.settings.employee_attendance_qr = this.settings.employee_attendance_qr ?? null;
			this.settings.client_type = this.settings.client_type ?? null;
      this.settings.payment_slip_size = this.settings.payment_slip_size ?? 0;
			this.settings.tax_rate = this.settings.tax_rate ? this.settings.tax_rate : 0;
			const normalizedDiscountLimit = this.normalizeDiscountLimit(this.settings.discount_limit);
			this.settings.discount_limit = normalizedDiscountLimit === '' ? 0 : normalizedDiscountLimit;
			this.settings.section_hourly_setting = this.settings.section_hourly_setting ?? CONFIG.SECTION_HOURLY_SETTING.SECTION;
			if (this.settings.section_hourly_setting != CONFIG.SECTION_HOURLY_SETTING.HOURLY) {
				this.settings.access_late_minute = null;
			}
			let request = {
				campus_id: this.$store.state.user.campus_id,
				api_user_id: this.apiUserId,
				settings: this.settings,
				file_change: this.isFileChange,
				facebook_integration: this.facebook_integration,
			};
			axios
				.post("/setting/save", request)
				.then((response) => {
					if (response.data.success) {
						this.$store.commit('setChatApproval', this.settings.teacher_chat_approval);
						this.$store.commit('setClientType', this.settings.client_type);
						this.$store.commit('setCurrency', this.settings.currency || 'MMK');
						this.$router.push({ name: 'customSettingPage' });
					}
					this.isLoading = false;
					this.disabled = false;
				})
				.catch((error) => {
					if (error.response && error.response.status == 401) {
						this.$store.commit('logout');
						window.location.replace('login');
					}
					if (error.response && error.response.status == 422) {
						this.$notification.error(error.response.data.message, {
							timer: 3,
							position: "bottomCenter"
						});
					}
					this.isLoading = false;
					this.disabled = false;
				});
		},

		/**
		 * sanitize positive integer
		 * @param {string|number|null|undefined} value Raw value from text/number inputs.
		 * @returns {number} Sanitized integer greater than or equal to 1.
		 */
		sanitizePositiveInteger(value) {
			const matched = String(value ?? '').match(/-?\d+(\.\d+)?/);
			if (!matched) return 1;
			const parsed = Math.floor(Math.abs(Number(matched[0])));
			return isNaN(parsed) || parsed <= 0 ? 1 : parsed;
		},

		/**
		 * sanitize tax rate
		 */
		sanitizeTax() {
			this.settings.tax_rate = this.sanitizePositiveInteger(this.settings.tax_rate);
		},

		/**
		 * keep discount limit within two digits only
		 * @param {string|number|null|undefined} value
		 * @returns {number|string}
		 */
		normalizeDiscountLimit(value) {
			const stringValue = String(value ?? '').trim();
			if (stringValue === '') return '';
			if (!isNaN(Number(stringValue)) && Number(stringValue) < 0) return 0;

			const digitsOnly = stringValue.replace(/\D/g, '').slice(0, 2);
			return digitsOnly === '' ? '' : Number.parseInt(digitsOnly, 10);
		},

		/**
		 * sanitize discount limit
		 * @param {InputEvent} event
		 */
		sanitizeDiscountLimit(event) {
			const rawValue = event?.target?.value ?? this.settings.discount_limit;
			this.settings.discount_limit = this.normalizeDiscountLimit(rawValue);
		},
	},
}
